import moment from 'moment';

const completeStatuses = [
  'Выполнена',
  'Выполнена(контроль качества)',
  'Закрыта',
];

export function isDateBetween(dateString, periodStart, periodEnd) {
  const date = moment(dateString);
  const start = moment(periodStart);
  const end = moment(periodEnd);

  return date.isBetween(start, end, null, '[]');
};

export function isPlanInPeriod(req, start, end) {
  if (!req?.executeDateTime) return false;

  const inPeriodExecute = isDateBetween(req.executeDateTime, start, end);

  return inPeriodExecute;
}

export function isFactInPeriod(req, start, end) {
  if (!req?.doneDateTime) return false; 
  if (!completeStatuses.includes(req.status)) return false

  const inPeriodDone = isDateBetween(req.doneDateTime, start, end);

  return inPeriodDone;
}

export function isClosedInPeriod(req, start, end) {
  if (!req?.closeDateTime) return false;

  const inPeriodClosed = isDateBetween(req.closeDateTime, start, end);

  return inPeriodClosed;
}

export function isFactWithClosedInPeriod(req, start, end) {
  // return isFactInPeriod(req, start, end) && isClosedInPeriod(req, start, end);
  return isClosedInPeriod(req, start, end);
}
